import * as React from 'react';

import {CloseButton} from '../button/close-button/close-button';
import {ButtonMover} from '../button-mover/button-mover';
import {LoadingPage} from '../loading-page/loading-page';
import {Sidebar} from '../sidebar/sidebar';

import {PersonDetailsContent} from './person-details-content/person-details-content';
import {SessionsContent} from './sessions-content/sessions-content';
import type {Person} from './visitor-content/company-people/company-people';
import {VisitorContent} from './visitor-content/visitor-content';
import type {Company} from './visitor-content/visitor-content';

import styles from './visitor-sidebar.module.css';

export type ContentView =
    | 'VISITOR'
    | 'SESSIONS'
    | {
          personId: string;
      };

type Props = {
    onClose: () => any;
    company:
        | (Company & {
              sessionsTimeline: React.ReactNode;
          })
        | null
        | undefined;
    people: Person[] | null | undefined;
    onAddPeople: (peopleIds: string[]) => Promise<any>;
    onAddCompany: (peopleIds: string[], buttonRef: any, onConfirmAdd: () => void) => any;
    isDisabled?: boolean;
    unlocksRemaining: number | null | undefined;
};

export function VisitorSidebar(props: Props) {
    const {company} = props;

    const [contentView, setContentView] = React.useState<ContentView>('VISITOR');

    let sidebarContent = <LoadingPage padding={0} />;
    if (company) {
        const {sessionsTimeline, ...restCompany} = company;
        if (typeof contentView === 'string') {
            switch (contentView) {
                case 'VISITOR':
                    sidebarContent = (
                        <VisitorContent
                            company={{...restCompany}}
                            people={props.people}
                            setContentView={(view) => setContentView(view)}
                            onClose={props.onClose}
                            onAddPeople={props.onAddPeople}
                            onAddCompany={props.onAddCompany}
                            unlocksRemaining={props.unlocksRemaining}
                        />
                    );
                    break;
                case 'SESSIONS':
                    sidebarContent = (
                        <SessionsContent
                            session={company.session}
                            sessionsTimeline={sessionsTimeline}
                            onClickBack={() => setContentView('VISITOR')}
                        />
                    );
                    break;
            }
        } else {
            const selectedPerson = props.people
                ? props.people.find((person) => person.id === contentView.personId)
                : undefined;
            if (selectedPerson) {
                sidebarContent = (
                    <PersonDetailsContent
                        person={selectedPerson}
                        onClickBack={() => setContentView('VISITOR')}
                    />
                );
            }
        }
    }

    return (
        <Sidebar
            isOpen={true}
            preventBodyScroll={false}
            canClickOutsideToClose={true}
            canEscapeToClose={true}
            onClose={props.onClose}
        >
            <div
                className={
                    props.isDisabled
                        ? styles['content-container--disabled']
                        : styles['content-container']
                }
            >
                <div className={styles['close-button']}>
                    <ButtonMover size='normal' direction={['right', 'up']}>
                        <CloseButton onClick={props.onClose} />
                    </ButtonMover>
                </div>
                {sidebarContent}
            </div>
        </Sidebar>
    );
}
